import React from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { Tag } from "antd";

const ReferralSummary = ({ dashboard, loading }) => {
  const userData = useSelector((state) => state.userProfile.dataFetched);

  const summaryData = [
    {
      key: 1,
      value: dashboard?.userReferred ?? dashboard?.totalReferred ?? dashboard?.tier1Referred,
      label: "User referred",
      isCurrency: false,
      className: "_1",
    },
    {
      key: 2,
      value: dashboard?.groupAccountsReferred ?? 0,
      label: "Group accounts referred",
      isCurrency: false,
      className: "_2",
    },
    {
      key: 3,
      value: dashboard?.totalEarnings,
      label: "Referral Income",
      isCurrency: true,
      className: "_3",
    },
    {
      key: 4,
      value: dashboard?.pendingEarnings,
      label: "Sales Income",
      isCurrency: true,
      className: "_4",
    },
  ];

  const cashbackData = [
    {
      label: "Sales income",
      value: dashboard?.weeklyCashback?.salesCashback,
      showMultiplierBadge: true,
    },
    {
      label: "Referral income",
      value: dashboard?.weeklyCashback?.referralCashback,
      showMultiplierBadge: true,
    },
    {
      label: "My cashback",
      value: dashboard?.weeklyCashback?.myCashback ?? dashboard?.weeklyCashback?.topEaterCashback,
      showMultiplierBadge: false,
    },
  ];

  return (
    <>
      <div className="grid-2 content-grid-cover">
        {summaryData.map((item) => (
          <SummaryBox
            key={item.key}
            value={item.value}
            label={item.label}
            isCurrency={item.isCurrency}
            loading={loading}
            className={item.className}
          />
        ))}
      </div>
      {dashboard?.weeklyCashback && (
        <div className="bg-amber-50 text-xl border-2 border-gray-100 rounded-2xl p-5 shadow-sm mt-4">
          <h4 className="font-gilroyBold text-xl text-gray-900 mb-4">
            This Week's Cashback Summary
          </h4>
          <div className="space-y-4">
            {cashbackData.map((item, idx) => (
              <div
                key={idx}
                className="flex justify-between items-center pb-3 border-b border-gray-100 last:border-0 last:pb-0"
              >
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-700">
                    {item.label}
                  </span>
                  {userData?.isAmbassador && item.showMultiplierBadge && (
                    <Tag color="blue" className="font-bold rounded-md text-xs py-1 px-2">
                      3x Multiplier
                    </Tag>
                  )}
                </div>
                <span className="font-bold text-gray-900">
                  ₦
                  <NumberFormat
                    thousandSeparator={true}
                    prefix={""}
                    className="numeric"
                    displayType={"text"}
                    value={(+(item.value || 0)).toFixed(2)}
                  />
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const SummaryBox = ({ value, label, isCurrency, loading, className }) => (
  <div className={`content-summary-box ${className}`}>
    <div className="content-summary-info">
      <h4>
        {!loading ? (
          isCurrency ? (
            <>
              <span className="currency">NGN</span>
              <NumberFormat
                thousandSeparator={true}
                prefix={""}
                className="numeric"
                displayType={"text"}
                value={(+(value || 0)).toFixed(2)}
              />
            </>
          ) : (
            (value ?? "0")
          )
        ) : (
          "-"
        )}
      </h4>
      <p>{label}</p>
    </div>
  </div>
);

export default ReferralSummary;
